import defaultState from 'utils/defaultState';

const isNotInDefaultState = (currentState: Record<string, any>) => currentState !== defaultState;

export default isNotInDefaultState;
